import React, {useState, useEffect, useMemo} from "react";

export function DonateWithPaypal({track}) {

    useEffect(() => {
        function render() {
            if (document.querySelector('#donate-button img')) return;
            try {
                window.PayPal.Donation.Button({
                    env: 'production',
                    hosted_button_id: 'GRTSTBCQ5BLW8',
                    image: {
                        src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif',
                        alt: 'Donate with PayPal button',
                        title: 'PayPal - The safer, easier way to pay online!',
                    }
                }).render('#donate-button');
            } catch(err) {
                console.error(err)
            }
        }

        if (!window.PayPal) {
            loadScript('https://www.paypalobjects.com/donate/sdk/donate-sdk.js', render)
        } else {
            render()
        }
    }, [])

    return ((
        <div className={"flex flex-row items-center justify-center gap-4"}><a onClick={() => track("Coffee clicked")}
                                                                              href="https://www.buymeacoffee.com/adasq"
                                                                              target="_blank"><img
            src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee"
            style={{height: '60px', width: '217px'}}/></a>
            <p>or</p>
            <div id="donate-button-container" className={"flex flex-col gap-1"}>
                <div id="donate-button" className={"flex justify-center"}></div>
                <div  className={"flex justify-center text-xs text-amber-300"}>with PayPal</div>
            </div>
        </div>))
}

function loadScript(url, callback) {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
        if (callback) callback();
    };

    script.onerror = () => {
        console.error(`Failed to load script: ${url}`);
    };

    document.head.appendChild(script);
}